import type { KLineData } from 'klinecharts'

/**
 * Heikin Ashi transform on klinecharts bars. HA close = avg(o,h,l,c); HA open =
 * avg(prev HA open, prev HA close); high/low extend to include the HA body.
 *
 * Note: HA is recursive, so a paginated chunk transformed on its own is seeded
 * from its first raw candle — a tiny discontinuity at chunk boundaries that
 * fades within a few bars. Acceptable for the sketching workbench.
 */
export function toHeikinAshi(bars: KLineData[]): KLineData[] {
  const out: KLineData[] = []
  for (let i = 0; i < bars.length; i++) {
    const b = bars[i]
    const close = (b.open + b.high + b.low + b.close) / 4
    const prev = out[i - 1]
    const open = prev ? (prev.open + prev.close) / 2 : (b.open + b.close) / 2
    out.push({
      timestamp: b.timestamp,
      open,
      close,
      high: Math.max(b.high, open, close),
      low: Math.min(b.low, open, close),
      volume: b.volume,
    })
  }
  return out
}
